import { NavigationUserName } from 'shared/components/layout/Layout.styles';
import { Dropdown, Menu } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import userStorage from 'utilities/user/userStorage';
import { LogoutOutlined } from '@ant-design/icons';

interface NavigationMenuProps {
  logOut: () => void;
}

function NavigationMenu({ logOut }: NavigationMenuProps) {
  return (
    <Menu>
      <Menu.Item icon={<LogoutOutlined />} onClick={logOut} data-testid="log-out">
        Log out
      </Menu.Item>
    </Menu>
  );
}

export function NavigationRightTools() {
  const { push } = useHistory();
  const user = userStorage.getUser();

  const logOut = () => {
    userStorage.removeUserAndToken();
    push('/login');
  };

  return (
    <Dropdown overlay={<NavigationMenu logOut={logOut} />}>
      <NavigationUserName data-testid="user-menu">
        <div>{user?.firstName.substring(0, 1)}</div>
        <div>
          {user?.firstName} {user?.lastName}
        </div>
      </NavigationUserName>
    </Dropdown>
  );
}
